import { CliOutput } from "@/lib/cli/cli-output";

export const out = new CliOutput();
